import React, { useState } from "react";
import Icon from "../../../components/AppIcon.jsx";
import Button from "../../../components/ui/Button.jsx";
import Input from "../../../components/ui/Input.jsx";

const contactInfo = [
  { icon: "Mail", label: "Email", value: "rehmat.ullah.network@gmail.com", href: "mailto:rehmat.ullah.network@gmail.com" },
  { icon: "MapPin", label: "Location", value: "Bahawalpur,Punjab,Pakistan", href: null },
  { icon: "Clock", label: "Availability", value: "Mon–Fri, 9AM–6PM EST", href: null },
  { icon: "DollarSign", label: "Freelance Rate", value: "$40–$80 / hour", href: null },
];

const socialLinks = [
  { name: "GitHub", icon: "Github", url: "https://github.com/rehmatcodemaster", username: "rehmatcodemaster" },
  { name: "Fiver", icon: "Fiver", url: "https://www.fiverr.com/users/rehmatullahulla/seller_dashboard", username: "@rehmatullahulla" },
  { name: "instagram", icon: "Instagram", url: "https://www.instagram.com/rehmat_ullah7786/", username: "rehmat_ullah7786" },
];

export default function ContactSection() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const e = {};
    if (!form?.name?.trim()) e.name = "Name is required";
    if (!form?.email?.trim()) e.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(form?.email)) e.email = "Enter a valid email";
    if (!form?.subject?.trim()) e.subject = "Subject is required";
    if (!form?.message?.trim()) e.message = "Message is required";
    else if (form?.message?.trim()?.length < 20) e.message = "Message must be at least 20 characters";
    return e;
  };

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e?.target?.value }));
    if (errors?.[field]) setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const errs = validate();
    if (Object.keys(errs)?.length > 0) {
      setErrors(errs);
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setForm({ name: "", email: "", subject: "", message: "" });
    }, 1500);
  };

  return (
    <div id="contact" className="py-16 md:py-20" style={{ background: "var(--color-background)" }}>
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: "var(--color-primary)", fontFamily: "var(--font-caption)" }}>
            Let's Work Together
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            Get In Touch
          </h2>
          <p className="text-sm md:text-base max-w-xl mx-auto" style={{ color: "var(--color-muted-foreground)" }}>
            Have a project in mind or want to discuss opportunities? I'd love to hear from you.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          {/* Contact Info */}
          <div className="lg:w-80 flex-shrink-0">
            <div className="space-y-4 mb-8">
              {contactInfo?.map((item) => (
                <div
                  key={item?.label}
                  className="flex items-center gap-3 p-4 rounded-xl border transition-all duration-200 hover:border-primary"
                  style={{ background: "var(--color-card)", borderColor: "var(--color-border)" }}
                >
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0"
                    style={{ background: "rgba(124,106,247,0.12)" }}
                  >
                    <Icon name={item?.icon} size={18} color="var(--color-primary)" />
                  </div>
                  <div className="min-w-0">
                    <div className="text-xs mb-0.5" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                      {item?.label}
                    </div>
                    {item?.href ? (
                      <a
                        href={item?.href}
                        className="text-sm font-medium hover:underline truncate block"
                        style={{ color: "var(--color-primary)", fontFamily: "var(--font-body)" }}
                      >
                        {item?.value}
                      </a>
                    ) : (
                      <span className="text-sm font-medium" style={{ color: "var(--color-foreground)" }}>
                        {item?.value}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Social Links */}
            <div>
              <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                Connect With Me
              </p>
              <div className="space-y-2">
                {socialLinks?.map((s) => (
                  <a
                    key={s?.name}
                    href={s?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 p-3 rounded-xl border transition-all duration-200 hover:border-primary group"
                    style={{ background: "var(--color-card)", borderColor: "var(--color-border)" }}
                  >
                    <Icon name={s?.icon} size={18} color="var(--color-muted-foreground)" />
                    <div>
                      <div className="text-sm font-medium" style={{ color: "var(--color-foreground)", fontFamily: "var(--font-heading)" }}>
                        {s?.name}
                      </div>
                      <div className="text-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                        {s?.username}
                      </div>
                    </div>
                    <Icon name="ExternalLink" size={14} color="var(--color-muted-foreground)" className="ml-auto" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="flex-1 min-w-0">
            <div
              className="p-6 md:p-8 rounded-xl border"
              style={{ background: "var(--color-card)", borderColor: "var(--color-border)" }}
            >
              {submitted ? (
                <div className="flex flex-col items-center justify-center py-12 text-center">
                  <div
                    className="w-16 h-16 rounded-xl flex items-center justify-center mb-4"
                    style={{ background: "rgba(34,197,94,0.12)" }}
                  >
                    <Icon name="CheckCircle" size={32} color="var(--color-success)" />
                  </div>
                  <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
                    Message Sent!
                  </h3>
                  <p className="text-sm mb-6" style={{ color: "var(--color-muted-foreground)" }}>
                    Thanks for reaching out. I'll get back to you within 24 hours.
                  </p>
                  <Button variant="outline" onClick={() => setSubmitted(false)}>
                    Send Another Message
                  </Button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <Input
                      label="Full Name"
                      type="text"
                      placeholder="John Smith"
                      value={form?.name}
                      onChange={handleChange("name")}
                      error={errors?.name}
                      required
                    />
                    <Input
                      label="Email Address"
                      type="email"
                      placeholder="john@example.com"
                      value={form?.email}
                      onChange={handleChange("email")}
                      error={errors?.email}
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <Input
                      label="Subject"
                      type="text"
                      placeholder="Project inquiry, job opportunity, etc."
                      value={form?.subject}
                      onChange={handleChange("subject")}
                      error={errors?.subject}
                      required
                    />
                  </div>
                  <div className="mb-6">
                    <label className="block text-sm font-medium mb-1.5" style={{ color: "var(--color-foreground)", fontFamily: "var(--font-body)" }}>
                      Message <span style={{ color: "var(--color-error)" }}>*</span>
                    </label>
                    <textarea
                      rows={5}
                      placeholder="Tell me about your project or opportunity..."
                      value={form?.message}
                      onChange={handleChange("message")}
                      className="w-full px-3 py-2.5 text-sm rounded-xl border resize-none focus:outline-none focus:ring-2 transition-all duration-200"
                      style={{
                        background: "var(--color-background)",
                        borderColor: errors?.message ? "var(--color-error)" : "var(--color-input)",
                        color: "var(--color-foreground)",
                        fontFamily: "var(--font-body)",
                      }}
                    />
                    {errors?.message && (
                      <p className="text-xs mt-1" style={{ color: "var(--color-error)" }}>{errors?.message}</p>
                    )}
                  </div>
                  <Button
                    variant="default"
                    size="lg"
                    fullWidth
                    loading={loading}
                    iconName="Send"
                    iconPosition="right"
                    type="submit"
                  >
                    Send Message
                  </Button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}